export { default as Home } from './Home';
export { default as Carta } from './Carta';
export { default as AllBars } from './AllBars';
export { default as Register } from './Register';